import React from 'react'
import unslugify from "unslugify";
import tableOrderUpdatedV2 from '../../subscription/tableOrderUpdatedV2'
import getSiteOrderByItemStatus from '../../queries/getSiteOrderByItemStatus'
import { Card, Row, Col, Button, List, Spin, Input, Select} from "antd";
import moment from 'moment'
import { withApollo } from '@apollo/client/react/hoc';
import '@ant-design/compatible/assets/index.css';
import updateTableOrderItemStatus from '../../mutations/updateTableOrderItemStatus';
import { roundToThree } from '../../utils/round';
import { SearchManager } from "./searchManager";
import { SearchInput } from "./searchInput";
import { renderAddons } from '../../utils/renderAddons';


class serveItems extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dataSource: null,
            platform: null,
            createDataSpin: false,
            loading: false,
            serviceId: '',
            subOrderId:'',
                 Sort:
        localStorage.getItem("SortItem") &&
        localStorage.getItem("SortItem") == "true"
          ? true
          : false,
      // Sort: true,
     searchOrderId: "",
  searchTableName: "",
  searchTokenNumber: "",
        };
        
  this.searchManager = new SearchManager(this.props.preTagFromApi);
    }

    componentDidMount = () => {
        if (window.screen.width >= 700) {
            this.setState({
                platform: 'desktop'
            })
        } else {
            this.setState({
                platform: 'mobile'
            })
        }
         
        this.setState({ createDataSpin: true })
        
        this.getSiteOrder()

        this.tableOrderUpdatedV2SubscriptionCall()

    }

    componentWillUnmount() {
        if(this.subscriptionV2){
            this.subscriptionV2.unsubscribe()
        }
      }

    getSiteOrder = () => {
      this.loadingSpin()
        this.props.client.query({
            query: getSiteOrderByItemStatus,
            fetchPolicy: 'network-only',
            variables: {
                station: this.props.station,
                // station:'kitchen',
                status: ['PREPARED','CANCELLED','COMPLETED','SHIFTED','DISCARDED'],
                skip: 0,
                limit: 1000
                // tableNo:'1'

            }
        })
            .then(({ data }) => {
                //   console.log("data",data)
                if (data.getSiteOrderByItemStatus != null && data.getSiteOrderByItemStatus.length > 0) {
                  
                    //  console.log("Query::", data.getSiteOrderByItemStatus)
                    let Data = JSON.parse(JSON.stringify(data.getSiteOrderByItemStatus))

                    let copy = Data && Data.length > 0 && Data.filter((order) => {
                        let flag = false;
                        order.orderList.map((item) => {
                            if (item.services.length > 0) {
                                flag = true;
                            }
                        })

                        if (flag) {
                            return order
                        }
                    })

                    this.createData(copy)
                    // console.log("Copy:::", copy)



                    //this.setState({dataSource:copy})
                }else{
                    this.setState({
                        createDataSpin: false,
                        dataSource: []
                    })
                }
            })
            .catch(err => {
                console.log(`Catch: handleFormSubmit: query error: ${JSON.stringify(err, null, 2)}`,err)
            })
    }

    tableOrderUpdatedV2SubscriptionCall = () => {
        let that = this
        let retryAttempts = 0; 
        this.subscriptionV2 = this.props.client.subscribe({
            query: tableOrderUpdatedV2,
            variables: {
                siteId: this.props.siteId
            }
        }).subscribe({
            next: ({ data }) => {
                retryAttempts = 0;
                let item = data.tableOrderUpdatedV2
                if (item.tableOrderStatus == "CLOSED") {
                    let FilterDataSOurce = this.state.dataSource.filter((order) => order.orderId != item.orderId)
                    if (FilterDataSOurce) {
                        this.setState({ dataSource: FilterDataSOurce })
                    } else {
                        this.setState({ dataSource: [] })
                    }
                }else{
                    this.createOnUpdate(item, null)
                }
            },
            error: (err) => {
                retryAttempts++;
                console.log('tableOrderUpdatedV2  error', err);
                const maxRetryAttempts = 5;

                if (retryAttempts <= maxRetryAttempts) {
                  const delay = Math.pow(2, retryAttempts) * 1000; // Exponential backoff with base 2
                  setTimeout(this.tableOrderUpdatedV2SubscriptionCall, delay);
                } else {
                  console.log('Max retry attempts reached. Stopping retries.');
                }
            }
        });
    }

    createData = (data) => {

        let finalData = this.filterBYKOtID(data)

         let flag = localStorage.getItem("SortItem");
    flag = flag === "true";

    if (flag) {
      finalData.sort((a, b) => a.kotId - b.kotId);
    } else {
      finalData.sort((a, b) => b.kotId - a.kotId);
    }

        let arr = []
        finalData.map((val, i) => {
            if (val.orderStatus !== 'DISPATCHED') {
                let obj = {}
                let count = 0
                let totalCount = 0
                let newCount = 0
                let inProcessCount = 0
                let Prepared = 0
                obj['id'] = val.id
                obj['orderId'] = val.orderId
                obj['kotId'] = val.kotId
                obj['tokenId'] = val.tokenId
                obj['name'] = val.name
                obj['tableNo'] = val.tableNo
                obj['updatedAt'] = val.updatedAt
                obj['timestamp'] = val.timestamp
                obj['orderFrom'] = val.orderFrom
                obj['orderSource'] = val.orderSource
                obj['subOrderFrom'] = val.subOrderFrom
                obj['newOrderFlag'] = val.newOrderFlag
                obj['noOfGuest'] = val.noOfGuest
                let arr2 = []
                val.orderList.map((k) => {
                    let obj2 = {}
                    obj2['subOrderId'] = k.subOrderId
                    let arr3 = []
                    k.services.map((s) => {
                        let obj3 = { ...s }
                        if (s.station == this.props.station) {
                            count++
                            totalCount = totalCount + 1
                            // totalCount = totalCount + s.qty
                            // obj3['serviceId'] = s.serviceId
                            // obj3['serviceName'] = s.serviceName
                            // obj3['qty'] = s.qty
                            // obj3['status'] = s.status
                            // obj3['station'] = s.station
                            // obj3['isUrgent'] = s.isUrgent
                            // obj3['instruction'] = s.instruction
                            arr3.push(obj3)

                        }
                        if (s.station == this.props.station && s.status == 'NEW') {
                            // newCount = newCount + 1
                        }
                        if (s.station == this.props.station && s.status == 'IN_PROCESS') {
                            inProcessCount = inProcessCount + 1
                        }
                        if (s.station == this.props.station && s.status == 'PREPARED') {
                            Prepared = Prepared + 1
                        }
                    })
                    if (arr3.length > 0) {
                        obj2['services'] = arr3
                        arr2.push(obj2)
                    }

                })
              
                if (arr2.length > 0) {
                    obj['orderList'] = arr2
                    obj['totalItems'] = count
                    obj['newCount'] = newCount
                    obj['inProcessCount'] = inProcessCount
                    obj['Prepared'] = Prepared
                    obj['totalCount'] = totalCount
                    obj['tableOrderStatus'] = val.tableOrderStatus
                    arr.push(obj)
                }
            }
            // console.log('Count::', count)
        })

        let copy = arr && arr.length > 0 && arr.filter((item)=>{
            if( item.Prepared > 0 ){
               return item
            }
          
       })
          
       if(copy){

           this.setState({
               createDataSpin: false,
               dataSource: copy
           })
       }else{
           this.setState({
               createDataSpin: false,
               dataSource: []
           })
       }

        // this.setState({
        //     createDataSpin: false,
        //     dataSource: arr
        // })
    }

    createOnUpdate=(data)=>{
        let updatedData = []
        updatedData.push(data)
 
        let finalData = this.filterBYKOtID(updatedData)
         
        let finalStateData = this.state.dataSource  && this.state.dataSource.length > 0 ? JSON.parse(JSON.stringify(this.state.dataSource))  : []
 
        if(finalStateData.length == 0){
         finalStateData = [...finalData, ...finalStateData]
        }else{
            
             for(let i=0; i<finalStateData.length;i++){
                 let index = -1
                 let temp = -1
                 for(let j=0; j<finalStateData.length;j++){
                    index = finalData.findIndex(item => item.kotId == finalStateData[j].kotId && item.orderId == finalStateData[j].orderId)
                    if(index != -1){
                     temp = j
                      break;
                    }
                 }
                   if(index != -1 && temp != -1){
                       finalStateData[temp] = finalData[index]
                       finalData.splice(index,1)
                   }
             }
              finalStateData = [...finalData, ...finalStateData]
        }
        
        let arr = []
        finalStateData.map((val, i) => {
        if(val.orderStatus!=='DISPATCHED'){
            let obj = {}
            let count = 0
            let totalCount = 0
           let newCount=0
           let Prepared = 0
           let inProcessCount = 0
            obj['id'] = val.id
            obj['orderId'] = val.orderId
            obj['kotId'] = val.kotId
            obj['tokenId'] = val.tokenId
            obj['name'] = val.name
            obj['tableNo'] = val.tableNo
            obj['updatedAt'] = val.updatedAt
            obj['timestamp'] = val.timestamp
            obj['orderFrom']=val.orderFrom
            obj['orderSource'] = val.orderSource
            obj['subOrderFrom']=val.subOrderFrom
            obj['newOrderFlag']=val.newOrderFlag
            obj['noOfGuest'] = val.noOfGuest
            let arr2 = []
            val.orderList.map((k) => {
                let obj2 = {}
                obj2['subOrderId'] = k.subOrderId
                let arr3 = []
                k.services.map((s) => {
                    let obj3 = {...s}
                    if (s.station==this.props.station && (s.status =='PREPARED' || s.status == 'CANCELLED' || s.status == 'COMPLETED' || s.status == 'SHIFTED' || s.status == 'DISCARDED')) {
                        count++
                        // totalCount = totalCount + s.qty
                        totalCount = totalCount + 1
                        
                        arr3.push(obj3)
 
                    }
                    if(s.station==this.props.station && s.status=='NEW'){
                        // newCount = newCount + 1
                    }
                    if(s.station==this.props.station && s.status=='IN_PROCESS'){
                        inProcessCount = inProcessCount + 1
                    }
                    if(s.station==this.props.station && s.status=='PREPARED'){
                        Prepared = Prepared + 1
                    }
                })
                if (arr3.length > 0) {
                    obj2['services'] = arr3
                    arr2.push(obj2)
                }
 
            })
            if (arr2.length > 0) {
                obj['orderList'] = arr2
                obj['totalItems'] = count
                obj['newCount'] = newCount
                obj['inProcessCount'] = inProcessCount
                obj['Prepared'] = Prepared
                obj['totalCount'] = totalCount
                obj['tableOrderStatus'] = val.tableOrderStatus
                arr.push(obj)
            }
        }
            // console.log('Count::', count)
        })
          
        let flag = localStorage.getItem('SortItem');
        flag = flag === 'true';

        if (flag) {
            finalStateData.sort((a, b) => a.kotId - b.kotId);
        } else {
            finalStateData.sort((a, b) => b.kotId - a.kotId);
        }
      
        let copy = arr && arr.length > 0 && arr.filter((item)=>{
             if( item.Prepared > 0 ){
                return item
             }
        })
           
        if(copy){
            this.setState({
                createDataSpin: false,
                dataSource: copy
            })
        }else{
            this.setState({
                createDataSpin: false,
                dataSource: []
            })
        }
 
     }

    createDataV2 = (val, serviceStatus) => {
        let arr = this.state.dataSource
        let obj = {}
        let count = 0
        let totalCount = 0
        let newCount = 0
        let inProcessCount = 0
        obj['id'] = val.id
        obj['orderId'] = val.orderId
        obj['tokenId'] = val.tokenId
        obj['name'] = val.name
        obj['tableNo'] = val.tableNo
        obj['updatedAt'] = val.updatedAt
        obj['timestamp'] = val.timestamp
        obj['orderFrom'] = val.orderFrom
        obj['orderSource'] = val.orderSource
        obj['subOrderFrom'] = val.subOrderFrom
        // obj['newOrderFlag']=val.newOrderFlag
        let arr2 = []
        val.orderList.map((k) => {
            let obj2 = {}
            obj2['subOrderId'] = k.subOrderId
            obj2['customFeilds'] = k.customFeilds

            let arr3 = []
            k.services.map((s) => {

                let obj3 = { ...s }

                // if (s.status == serviceStatus && s.station==this.state.station ) {
                if (s.station == this.props.station && s.status == 'PREPARED') {



                    count++
                    totalCount = totalCount + 1
                    // totalCount = totalCount + s.qty
                    // obj3['serviceId'] = s.serviceId
                    // obj3['serviceName'] = s.serviceName
                    // obj3['qty'] = s.qty
                    // obj3['status'] = s.status
                    // obj3['station'] = s.station
                    // obj3['isUrgent'] = s.isUrgent
                    // obj3['instruction'] = s.instruction
                    arr3.push(obj3)

                }
                if (s.station == this.props.station && s.status == 'NEW') {
                    newCount = newCount + 1
                }
                if (s.station == this.props.station && s.status == 'IN_PROCESS') {
                    inProcessCount = inProcessCount + 1
                }
            })
            if (arr3.length > 0) {
                obj2['services'] = arr3
                arr2.push(obj2)
            }

        })
        let foundIndex = arr.findIndex(x => x.id == val.id);
        if (arr2.length > 0) {
            obj['orderList'] = arr2
            obj['totalItems'] = count
            obj['totalCount'] = totalCount
            obj['newCount'] = newCount
            obj['inProcessCount'] = inProcessCount
            obj['tableOrderStatus'] = val.tableOrderStatus
            arr && arr.length > 0 && arr.map((p) => {
                p['newOrderFlag'] = false
            })
            obj['newOrderFlag'] = true

            if (foundIndex >= 0) {
               // console.log("Found Index")
                arr[foundIndex] = obj
            } else {
                let flag = localStorage.getItem('SortItem');
                flag = flag === 'true';

                if (flag) {
                    arr.push(obj)
                } else {
                    arr.unshift(obj)
                }


            }



        } else if (foundIndex >= 0) {
            //console.log("removed case")
            arr.splice(foundIndex, 1)
            //console.log("arr:::",arr)
        }
        // arr.unshift(obj)
        // if(arr.length==1 && arr[0].orderList.length==1){
        //     this.getSiteOrder(this.state.kitchenStatus)
        // }

        try {
            // const audioEl = document.getElementsByClassName("audio-element")[0]
            // this.state.updateflag==false  &&  audioEl.play()
            this.setState({
                updateflag: false
            })
        } catch (e) {
            console.log('error catch::', e)
        }
        this.setState({
            createDataSpin: false,
            dataSource: arr
        })
    }

    filterBYKOtID = (orders) => {
        //  console.log("orders dd ::", orders)

        let response = [];
        let tmpKot = {};
        let newSubOrder = null;

        orders.forEach(order => {
            order.orderList.forEach(subOrder => {

                subOrder.services.forEach(service => {

                    if (service.kotId) {

                        if (!tmpKot[service.kotId]) {
                            order.timestamp = subOrder.createdAt
                            tmpKot[service.kotId] = Object.assign({}, order);

                            delete tmpKot[service.kotId].kotNo;

                            tmpKot[service.kotId].orderList = []

                            tmpKot[service.kotId].kotId = service.kotId

                            newSubOrder = {

                                "subOrderId": subOrder.subOrderId,

                                "createdAt": subOrder.createdAt,

                                "services": [Object.assign({}, service)]

                            }

                            tmpKot[service.kotId].orderList.push(newSubOrder);

                        } else {

                            let index = tmpKot[service.kotId].orderList.findIndex(obj => obj.subOrderId == subOrder.subOrderId);

                            if (index == -1) {

                                newSubOrder = {
                                    "subOrderId": subOrder.subOrderId,
                                    "createdAt": subOrder.createdAt,
                                    "services": [Object.assign({}, service)]
                                }

                                tmpKot[service.kotId].orderList.push(newSubOrder);

                            } else {
                                tmpKot[service.kotId].orderList[index].services.push(Object.assign({}, service))
                            }
                        }
                    }
                });
            });


            Object.keys(tmpKot).forEach(kot => {
                response.push(Object.assign({}, tmpKot[kot]))
            });
            tmpKot = {}
        });

        return response

    }

    showMenuName = (s) =>{

        let name = ''
         if(s.subOrderFrom){
              name = name + unslugify(s.subOrderFrom).toUpperCase()
              
              if(s.orderSource){
                name = name + " (" + unslugify(s.orderSource).toUpperCase() + " )"
              }
         }else{
            name = unslugify(s.orderFrom).toUpperCase()
         }
           
         return name
       
    }

    enterLoading = () => {
        this.setState({
            loading: true
        })
    }

    updateStatus = (id, subid, sid, status) => {
        this.props.client.mutate({
            mutation: updateTableOrderItemStatus,
            variables: {
                id: id,
                subOrderId: subid,
                serviceId: sid,
                status: status == 'PREPARED' ? 'IN_PROCESS' : 'PREPARED'
            }
        }).then(({ data }) => {
          
            this.createOnUpdate(data.updateTableOrderItemStatus)
            this.setState({
                loading: false,
                serviceId:'',
                subOrderId:''
            })

        }).catch(err => {
            console.log('errrr', err)
        })
    }

    undoItem = (id, subid, sid, status,uId) => {
        console.log("Undo")
        this.enterLoading()
        this.setState({
            serviceId: uId,
            subOrderId:subid
        }, () => {
            this.updateStatus(id, subid, uId, status)
        }
        )
    }

     handleSearch = (e) => {
    this.setState({ searchText: e.target.value });
  };


  onChange = (e) => {
    //console.log("onChange::",e)

    //return
    localStorage.setItem("SortItem", e);
    this.setState({ Sort: e });

    this.getSiteOrder();

    // console.log("Called::::",e.target.checked)
  };

  loadingSpin = () => {
    this.setState({
      createDataSpin: !this.state.createDataSpin,
    });
  };

  getSearchValue = (type) => {
  switch (type) {
    case "orderId":
      return this.state.searchOrderId;
    case "tableName":
      return this.state.searchTableName;
    case "tokenNumber":
      return this.state.searchTokenNumber;
    default:
      return "";
  }
};

 handleSearchChange = (type, value) => {
  const searchValue = value || this.getSearchValue(type);
  
  if (!searchValue || searchValue.trim() === "") {
    message.error("Please enter a search value");
    return;
  }

  this.searchManager.performSearch(type, searchValue.trim(), this.state.Sort);
   
};

  handleClearSearch = (type) => {
  switch (type) {
    case "orderId":
      this.setState({ searchOrderId: "" });
      break;
    case "tableName":
      this.setState({ searchTableName: "" });
      break;
    case "tokenNumber":
      this.setState({ searchTokenNumber: "" });
      break;
  }

    this.searchManager.clearPreviousHighlight();
};

   handleUndoItem = (id, subOrderId,serviceId,status,uId)=>{
  if (this.state.searchOrderId !== "") {
     this.searchManager.clearPreviousHighlight();
    this.state.searchOrderId = ""
  }
  if (this.state.searchTableName !== "") {
    this.searchManager.clearPreviousHighlight();
    this.state.searchTableName = ""
  }
  if (this.state.searchTokenNumber !== "") {
     this.searchManager.clearPreviousHighlight();
    this.state.searchTokenNumber = ""
  }

    this.undoItem( id,subOrderId,serviceId,status, uId);
  }

 componentDidUpdate(prevProps, prevState) {
 
    if (prevState.dataSource?.length !== this.state.dataSource?.length) {
      this.searchManager.clearPreviousHighlight()
         this.setState({
        searchOrderId:"",
        searchTableName:"",
        searchTokenNumber:""
    })
     
    }   
  }

    render() {

        let services = this.state.dataSource
        // console.log(services, "731")
        let TableData = this.props.tableData

        // console.log(this.props.preTagFromApi, "pre tag")
        const {Search} = Input

        // console.log("render", JSON.parse(JSON.stringify(this.state.dataSource)))

        return (
            <>  
                {this.state.createDataSpin == true ? <Spin /> :

                    this.state.platform == 'desktop' ? services && services.length > 0 ?
                    <>
                     <div
              style={{
                marginBottom: "10px",
                marginTop: "-20px",
                display: "flex",
                gap: "10px",
                alignItems: "center",
              }}
            >
              <Select
                defaultValue={this.state.Sort}
                style={{ width: "200px", marginBottom: "20px" }}
                onChange={this.onChange}
              >
                <Option value={true}>Oldest To Newest</Option>
                <Option value={false}>Newest To Oldest</Option>
              </Select>

              <div
                                  style={{
                                    display: "flex",
                                    gap: "10px",
                                    marginBottom: "20px",
                                  }}
                                >
                                  <SearchInput
                  placeholder="Order ID"
                  value={this.state.searchOrderId}
                  onChange={(e) => {
                    const newValue = e.target.value;
                    this.setState({ searchOrderId: newValue });
              
                    if (newValue === "" || newValue.trim() === "") {
                      this.searchManager.clearPreviousHighlight();
                    }
                  }}
                  onSearch={(value) => {
                    if (!value || value.trim() === "") {
                      this.handleClearSearch("orderId");
                      return;
                    }
                    this.handleSearchChange("orderId", value);
                  }}
                  onClear={() => this.handleClearSearch("orderId")}
                  style={{
                    flex: "1 1 200px",
                    minWidth: "150px",
                  }}
                />
              
                <SearchInput
                  placeholder="Table Name"
                  value={this.state.searchTableName}
                  onChange={(e) => {
                    const newValue = e.target.value;
                    this.setState({ searchTableName: newValue });
              
                    if (newValue === "" || newValue.trim() === "") {
                      this.searchManager.clearPreviousHighlight();
                    }
                  }}
                  onSearch={(value) => {
                    if (!value || value.trim() === "") {
                      this.handleClearSearch("tableName");
                      return;
                    }
                    this.handleSearchChange("tableName", value);
                  }}
                  onClear={() => this.handleClearSearch("tableName")}
                  style={{
                    flex: "1 1 200px",
                    minWidth: "150px",
                  }}
                />
              
                <SearchInput
                  placeholder="Token Number"
                  value={this.state.searchTokenNumber}
                  onChange={(e) => {
                    const newValue = e.target.value;
                    this.setState({ searchTokenNumber: newValue });
              
                    if (newValue === "" || newValue.trim() === "") {
                      this.searchManager.clearPreviousHighlight();
                    }
                  }}
                  onSearch={(value) => {
                    if (!value || value.trim() === "") {
                      this.handleClearSearch("tokenNumber");
                      return;
                    }
                    this.handleSearchChange("tokenNumber", value);
                  }}
                  onClear={() => this.handleClearSearch("tokenNumber")}
                  style={{
                    flex: "1 1 200px",
                    minWidth: "150px",
                  }}
                />
                                </div>
            </div>
                        <Row gutter={16}>
                            {
                                services.map((s) => {
                                    let tableName = ""
                                    TableData && TableData.length > 0 && TableData.map((item) => {
                                        if (item.typeValue == s.tableNo) {
                                            tableName = item.tableName
                                        }
                                    })


                                    return (
                                        <>
                                            {s.totalItems > 0 &&
                                                <Col xs={{ span: 24 }} md={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} style={{ paddingLeft: '0px', paddingRight: '0px' }} id={`refId${s.orderId}`} 
                                                data-order-id={s.orderId ? s.orderId.toString().toLowerCase() : ""}
  data-token-id={s.tokenId ? s.tokenId.toString().toLowerCase() : ""}
  data-table-name={tableName ? tableName.toLowerCase() : ""} >
                                                    <Card className="kitchenCards" style={{ border: s.newOrderFlag && '2px solid red' }}>
                                                        <Row>

                                                            <Col span={4} style={{ paddingLeft: '0px', paddingRight: '0px' }}>
                                                                <p className="kitcheNames" style={{ fontSize: '17px' }}>{s.name ? s.name.slice(0,8) + (s.name.length > 8 ? "..." : ""): ""}</p>
                                                                {/* <div style={{ display: "flex", }}>
                                                                    <p style={{ marginBottom: '0px', marginRight: "10px" }}><span className="kitcheNames">Order Id:</span> {s.orderId}</p>
                                                                    <p style={{ marginBottom: '0px', marginRight: "10px" }}><span className="kitcheNames">Token No:</span> {s.tokenId}</p>
                                                                    <p style={{ marginBottom: '0px' }}><span className="kitcheNames">KOT NO :</span> {s.kotId}</p>
                                                                </div> */}



                                                            </Col>
                                                            <Col span={s.orderFrom == 'dine-in' ? 10 : 14} style={{ paddingLeft: '0px', paddingRight: '0px' }}>
                                                                <div style={{ display: this.state.platform == 'desktop' && 'flex' }}>
                                                                    <p style={{ marginBottom: '0px', marginRight: '15px' }}>
                                                                        <Button
                                                                            style={{ borderRadius: '5px', background: s.orderFrom == 'dine-in' ? '#1b34b1' : s.orderFrom == 'online-menu' ? '#4e45a0' : '#f36b0a', height: '30px' }}>
                                                                            <span style={{ color: 'white' }}>{this.showMenuName(s)}</span></Button>
                                                                    </p>
                                                                    {s.orderFrom == 'dine-in' &&
                                                                        <p style={{ marginBottom: '0px', marginRight: '15px' }}>
                                                                            <Button style={{ borderRadius: '5px', background: '#27cfa0', height: '30px' }}><span style={{ color: 'white' }}>
                                                                                {/* <span className="kitcheNames" style={{ color: 'white' }}>Table:</span> {s.tableNo ? s.tableNo.split('::')[1] : ''} */}
                                                                                <span className="kitcheNames" style={{ color: 'white' }}>{tableName}</span>
                                                                            </span></Button>
                                                                        </p>
                                                                    }
                                                                    <p style={{ marginBottom: '0px', marginRight: '15px' }}>
                                                                        <Button style={{ borderRadius: '5px', background: '#9db519', height: '30px' }}><span style={{ color: 'white' }}>
                                                                            <span className="kitcheNames" style={{ color: 'white' }}>ITEMS:</span> {roundToThree(s.totalCount)}
                                                                        </span></Button>
                                                                    </p>
                                                                </div>
                                                            </Col>
                                                            <Col span={6} style={{ paddingLeft: '0px', paddingRight: '0px' }}>
                                                                <p className="kitcheNames" style={{ textAlign: 'right', marginRight: s.orderFrom == "dine-in"? "-90px" : "-7px" }}> <span style={{ fontWeight: 500 }}>{s.timestamp && moment.unix(s.timestamp).format('DD-MM-YYYY hh:mm a')}</span>&nbsp;
                                                                </p>

                                                            </Col>
                                                        </Row>
                                                        <div>
                                                                 <div style={{ display: "flex",marginTop:"4px", marginBottom:"10px"}}>
                                                                            <p style={{ marginBottom: '0px', marginRight: "10px" }}><span className="kitcheNames">Order Id:</span> {s.orderId}</p>
                                                                            <p style={{ marginBottom: '0px', marginRight: "10px" }}><span className="kitcheNames">Token No:</span> {s.tokenId}</p>
                                                                            <p style={{ marginBottom: '0px',marginRight: "10px"  }}><span className="kitcheNames">KOT NO :</span> {s.kotId}</p>
                                                                              {s.noOfGuest ? <p style={{ marginBottom: '0px' }}><span className="kitcheNames">Guests :</span> {s.noOfGuest}</p> : ''}
                                                                 </div>
                                                        </div> 
                                                        <hr style={{ marginTop: '0px', marginBottom: '0px' }} />

                                                        {s.orderList && s.orderList.map((order) => {
                                                            return (
                                                                <div
                                                                    id="scrollableDiv"
                                                                    style={{
                                                                        height: 'auto',
                                                                        overflow: 'auto',
                                                                        padding: '0 3px',
                                                                        borderBottom: '1px solid rgba(140, 140, 140, 0.35)',
                                                                    }}
                                                                >
                                                                    <List
                                                                        className="kitchenList"
                                                                        dataSource={order.services}
                                                                        renderItem={item => (
                                                                            <>

                                                                                <List.Item key={item.serviceId} className="kitchenItemsBorder">
                                                                                    <List.Item.Meta
                                                                                        className="listData"
                                                                                        title={
                                                                                            <Row>
                                                                                                <Col xs={{ span: 18 }} sm={{ span: 12 }} md={{ span: 14 }} lg={{ span: 14 }}>{item.serviceName}
                                                                                                    {/* {
                                                                                                        item.addons && <p style={{ marginBottom: '0px' }}> (
                                                                                                            {
                                                                                                                item.addons && item.addons.map((add, i) => {
                                                                                                                    return (
                                                                                                                        <>
                                                                                                                            <span>{add.serviceName} qty({add.qty ? add.qty : 1})</span>
                                                                                                                            {item.addons.length > i + 1 && <span>,&nbsp;</span>}
                                                                                                                        </>

                                                                                                                    )
                                                                                                                })
                                                                                                            })
                                                                                                        </p>
                                                                                                    } */}
                                                                                                    {item.addons &&
                                                                                                        <p style={{ marginBottom: "0px" }}>
                                                                                                            <strong>Addons:</strong>&nbsp;{renderAddons(item.addons)}
                                                                                                        </p>
                                                                                                    }
                                                                                                </Col>
                                                                                                <Col xs={{ span: 18 }} sm={{ span: 18 }} md={{ span: 6 }} lg={{ span: 6 }} >Qty: {item.qty}</Col>
                                                                                                {item.status != 'PREPARED' && item.isUrgent == true && <Col xs={{ span: 6 }} sm={{ span: 6 }} md={{ span: 2 }} lg={{ span: 2 }} style={{ marginTop: '-7px' }}><span style={{ color: 'red' }}>Urgent</span></Col>}
                                                                                                {item.instruction && item.instruction != '' && <p style={{ color: 'red', fontWeight: 600 }}>{`(${item.instruction})`}</p>}
                                                                                            </Row>
                                                                                        }

                                                                                    />

                                                                                    {item.status == 'PREPARED' &&
                                                                                        <div style={{display:"flex", justifyContent:'space-between',marginBottom: '7px',  }}>
                                                                                            <p style={{ textAlign: 'center', marginTop: '7px',  marginRight:"7px", color: '#3f51b5', fontWeight: 600 }}>
                                                                                                Ready to Serve
                                                                                            </p>
                                                                                            <Button 
                                                                                            loading={this.state.serviceId == item.uId && order.subOrderId == this.state.subOrderId && this.state.loading}
                                                                                            style={{ background: '#F14A52', color: 'white',  borderRadius: '5px' ,marginTop: '5px', }} 
                                                                                            // onClick={() => this.undoItem(s.id, order.subOrderId, item.serviceId, item.status, item.uId)}
                                                                                            onClick={()=> this.handleUndoItem(s.id, order.subOrderId, item.serviceId, item.status, item.uId)}
                                                                                            >
                                                                                             Undo
                                                                                            </Button>
                                                                                        </div>
                                                                                    }
                                                                                     {item.status == "COMPLETED" &&
                                                                                        <div style={{ margin: 'auto' , marginRight:"12%" }}>
                                                                                            <p style={{ textAlign: 'center', marginBottom: '7px', marginTop: '7px', color: '#3f51b5', fontWeight: 600 ,  }}>
                                                                                                COMPLETED</p>
                                                                                        </div>

                                                                                    }
                                                                                    {item.status == 'CANCELLED' &&
                                                                                        <div style={{ margin: 'auto', marginRight:"12%"  }}>
                                                                                            <p style={{ textAlign: 'center', marginBottom: '7px', marginTop: '7px', color: 'red', fontWeight: 600 }}>
                                                                                                CANCELLED</p>
                                                                                        </div>
                                                                                    }
                                                                                    {item.status == 'DISCARDED' &&
                                                                                        <div style={{ margin: 'auto', marginRight:"12%"  }}>
                                                                                            <p style={{ textAlign: 'center', marginBottom: '7px', marginTop: '7px', color: 'red', fontWeight: 600 }}>
                                                                                                CANCELLED</p>
                                                                                        </div>
                                                                                    }

                                                                                    {item.status == 'SHIFTED' &&
                                                                                        <div style={{ margin: 'auto' , marginRight:"12%" }}>
                                                                                            <p style={{ textAlign: 'center', marginBottom: '7px', marginTop: '7px', color: 'red', fontWeight: 600 }}>
                                                                                               SHIFTED</p>
                                                                                        </div>
                                                                                    }
                                                                                </List.Item>
                                                                            </>
                                                                        )}
                                                                    />
                                                                </div>
                                                            )
                                                        })}


                                                    </Card>
                                                </Col>
                                            }
                                        </>

                                    )
                                })
                            }

                        </Row> </> : <p style={{textAlign:'center',marginTop:'50px'}}><img src='/public/nodata.png' style={{height:'200px'}}/></p> : <>
                            <div
                                style={{
                                    marginBottom: "10px",
                                    marginTop: "-27px",
                                    display: "flex",
                                    flexWrap: "wrap",
                                    gap: "10px",
                                    alignItems: "center",
                                    justifyContent: "center",
                                }}
                            >
                                <Select
                                    defaultValue={this.state.Sort}
                                    style={{
                                        width: "200px",
                                        flex: "1 1 200px",
                                        minWidth: "150px",
                                    }}
                                    onChange={this.onChange}
                                >
                                    <Option value={true}>Oldest To Newest</Option>
                                    <Option value={false}>Newest To Oldest</Option>
                                </Select>

                                <div
                                    style={{
                                        display: "flex",
                                        flexWrap: "wrap",
                                        gap: "10px",
                                        flex: "3 1 600px",
                                        justifyContent: "flex-start",
                                    }}
                                >
                                    <SearchInput
                                        placeholder="Order ID"
                                        value={this.state.searchOrderId}
                                        onChange={(e) => {
                                            const newValue = e.target.value;
                                            this.setState({ searchOrderId: newValue });

                                            if (newValue === "" || newValue.trim() === "") {
                                                this.searchManager.clearPreviousHighlight();
                                            }
                                        }}
                                        onSearch={(value) => {
                                            if (!value || value.trim() === "") {
                                                this.handleClearSearch("orderId");
                                                return;
                                            }
                                            this.handleSearchChange("orderId", value);
                                        }}
                                        onClear={() => this.handleClearSearch("orderId")}
                                        style={{
                                            flex: "1 1 200px",
                                            minWidth: "150px",
                                        }}
                                    />

                                    <SearchInput
                                        placeholder="Table Name"
                                        value={this.state.searchTableName}
                                        onChange={(e) => {
                                            const newValue = e.target.value;
                                            this.setState({ searchTableName: newValue });

                                            if (newValue === "" || newValue.trim() === "") {
                                                this.searchManager.clearPreviousHighlight();
                                            }
                                        }}
                                        onSearch={(value) => {
                                            if (!value || value.trim() === "") {
                                                this.handleClearSearch("tableName");
                                                return;
                                            }
                                            this.handleSearchChange("tableName", value);
                                        }}
                                        onClear={() => this.handleClearSearch("tableName")}
                                        style={{
                                            flex: "1 1 200px",
                                            minWidth: "150px",
                                        }}
                                    />

                                    <SearchInput
                                        placeholder="Token Number"
                                        value={this.state.searchTokenNumber}
                                        onChange={(e) => {
                                            const newValue = e.target.value;
                                            this.setState({ searchTokenNumber: newValue });

                                            if (newValue === "" || newValue.trim() === "") {
                                                this.searchManager.clearPreviousHighlight();
                                            }
                                        }}
                                        onSearch={(value) => {
                                            if (!value || value.trim() === "") {
                                                this.handleClearSearch("tokenNumber");
                                                return;
                                            }
                                            this.handleSearchChange("tokenNumber", value);
                                        }}
                                        onClear={() => this.handleClearSearch("tokenNumber")}
                                        style={{
                                            flex: "1 1 200px",
                                            minWidth: "150px",
                                        }}
                                    />
                                </div>
                            </div>
                        {
                            services && services.length > 0 ?
                                <Row> {
                                    services.map((s) => {
                                        let tableName = ""

                                        TableData && TableData.length > 0 && TableData.map((item) => {
                                            if (item.typeValue == s.tableNo) {
                                                tableName = item.tableName
                                            }
                                        })

                                        return (
                                            <>
                                                {s.totalItems > 0 &&
                                                    <Col xs={{ span: 24 }} md={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} style={{ paddingLeft: '0px', paddingRight: '0px' }} id={`refId${s.orderId}`}
                                                        data-order-id={s.orderId ? s.orderId.toString().toLowerCase() : ""}
                                                        data-token-id={s.tokenId ? s.tokenId.toString().toLowerCase() : ""}
                                                        data-table-name={tableName ? tableName.toLowerCase() : ""}>
                                                        <Card className="kitchenCards" style={{ marginLeft: '0px', marginRight: '0px' }}>
                                                            <Row>
                                                                <Col span={12}>
                                                                <Row>
                                                                            <Col span={12}>
                                                                            <p style={{ marginBottom: '0px', textAlign: 'left' }}>
                                                                            {/* <Button style={{ borderRadius: '5px', background: s.orderFrom == 'dine-in' ? '#1b34b1' : '#f36b0a', height: '23px' }}> */}
                                                                            <span style={{ color: s.orderFrom == 'dine-in' ? '#1b34b1' : '#f36b0a', fontWeight: 600, fontSize: '17px', }}>{this.showMenuName(s)}</span>
                                                                            {/* </Button> */}
                                                                            </p>
                                                                            </Col>
                                                                            <Col span={12}>
                                                                            {s.orderFrom == 'dine-in' && <p style={{ marginBottom: '0px', textAlign: 'left' }}>
                                                                                
                                                                                <Button style={{ borderRadius: '5px', background: '#409ee9', height: '30px' }}><span style={{ color: 'white' }}>
                                                                                    <span className="kitcheNames" style={{ color: 'white', fontSize: '12px' }}>{tableName}</span>
                                                                                </span>
                                                                                </Button>
                                                                            </p>
                                                                            }
                                                                            </Col>
                                                                        </Row>
                                                                    
                                                                </Col>
                                                                <Col span={12}>
                                                                    <p className="kitcheNames" style={{ textAlign: 'right' }}> <span style={{ fontWeight: 500 }}>{s.timestamp && moment.unix(s.timestamp).format('DD-MM-YYYY hh:mm a')}</span>&nbsp;
                                                                    </p>
                                                                </Col>
                                                            </Row>

                                                            <Row>
                                                               
                                                                <Col span={24} style={{ textAlign: s.orderFrom == 'dine-in' ? 'end' : 'justify', marginTop: "4px" }} >
                                                                    <div style={{ display: "flex" }}>
                                                                        {/* <p style={{ marginBottom: '0px', marginRight: "15px", }}>
                                                                            <span className="kitcheNames" style={{ lineHeight: '26px',marginBottom: '0px', marginRight: "15px" }}>ORDER ID:{s.orderId ? s.orderId : ''}</span>
                                                                        </p>
                                                                        <p style={{ marginBottom: '0px', marginRight: "15px" }}>
                                                                            <span className="kitcheNames" style={{ lineHeight: '26px' }}>TOKEN NO:{s.tokenId ? s.tokenId : ''}</span>
                                                                        </p>
                                                                        <p style={{ marginBottom: '0px' }}><span className="kitcheNames" style={{ lineHeight: '26px' }}>KOT NO : {s.kotId}</span> </p> */}
                                                                         
                                                                        
                                                                            <span className="kitcheNames" style={{ lineHeight: '26px',marginBottom: '0px', marginRight: "10px",fontSize:"13px" }}>ORDER ID:{s.orderId ? s.orderId : ''}</span>
                                        
                                                                            <span className="kitcheNames" style={{ lineHeight: '26px',marginRight: "10px",fontSize:"13px" }}>TOKEN NO:{s.tokenId ? s.tokenId : ''}</span>
                                                                        
                                                                            <span className="kitcheNames" style={{ lineHeight: '26px',fontSize:"13px", marginRight: "10px"}}>KOT NO : {s.kotId}</span> 

                                                                           {s.noOfGuest ? <span className="kitcheNames" style={{ lineHeight: '26px',fontSize:"13px" }}>Guests: {s.noOfGuest}</span>  : <></>}
                                                                    
                                                                    </div>
                                                                </Col>

                                                            </Row>
                                                            <Row gutter={8} style={{ marginBottom: '10px', marginTop: '0px' }}>
                                                                <Col span={24} style={{ textAlign: 'justify' }}>
                                                                    <span className="kitcheNames" style={{ fontSize: '16px' }}>{s.name}</span>

                                                                </Col>


                                                            </Row>
                                                            <hr style={{ marginTop: '0px', marginBottom: '2px' }} />
                                                            {
                                                                s.orderList && s.orderList.length > 0 && s.orderList.map((order) => {
                                                                    return (
                                                                        <div
                                                                            id="scrollableDiv"
                                                                            style={{
                                                                                height: 'auto',
                                                                                overflow: 'auto',
                                                                                padding: '0 3px',
                                                                                borderBottom: '1px solid rgba(140, 140, 140, 0.35)',
                                                                            }}
                                                                        >
                                                                            <List
                                                                                className="kitchenList"
                                                                                dataSource={order.services}
                                                                                renderItem={item => (
                                                                                    <>
                                                                                        {/* {item.status == status && */}
                                                                                        <List.Item key={item.serviceId} className="kitchenItemsBorder">
                                                                                            <List.Item.Meta
                                                                                                className="listData"
                                                                                                // avatar={<Avatar src={item.picture.large} />}
                                                                                                title={<Row gutter={16}>
                                                                                                    <Col xs={{ span: 16 }} sm={{ span: 16 }} md={{ span: 18 }} lg={{ span: 18 }}>{item.serviceName}
                                                                                                        {/* {item.addons &&
                                                                                                            <p style={{ marginBottom: '0px' }}> (
                                                                                                                {item.addons && item.addons.map((add, i) => {
                                                                                                                    return (
                                                                                                                        <>
                                                                                                                            <span>{add.serviceName} qty({add.qty ? add.qty : 1})</span>
                                                                                                                            {item.addons.length > i + 1 && <span>,&nbsp;</span>}
                                                                                                                        </>

                                                                                                                    )
                                                                                                                })
                                                                                                                } )

                                                                                                            </p>
                                                                                                        } */}
                                                                                                        {item.addons &&
                                                                                                            <p style={{ marginBottom: "0px" }}>
                                                                                                                <strong>Addons:</strong>&nbsp;{renderAddons(item.addons)}
                                                                                                            </p>
                                                                                                        }
                                                                                                    </Col>
                                                                                                    <Col xs={{ span: 8 }} sm={{ span: 8 }} md={{ span: 8 }} lg={{ span: 6 }} >Qty: {item.qty}</Col>
                                                                                                    {item.status != 'PREPARED' && item.isUrgent == true && <Col xs={{ span: 6 }} sm={{ span: 6 }} md={{ span: 2 }} lg={{ span: 2 }} style={{ marginTop: '-7px' }}><span style={{ color: 'red' }}>Urgent</span></Col>}
                                                                                                    {item.instruction && item.instruction != '' && <p style={{ color: 'red', fontWeight: 600 }}>{`(${item.instruction})`}</p>}
                                                                                                </Row>
                                                                                                }

                                                                                            />

                                                                                            {item.status == 'PREPARED' &&
                                                                                                <div style={{ display:"flex", margin: 'auto' }}>
                                                                                                    <p style={{ textAlign: 'center', marginBottom: '7px',  marginRight:"7px", marginTop: '7px', color: '#3f51b5', fontWeight: 600 }}>
                                                                                                        Ready to Serve
                                                                                                    </p>
                                                                                                    <Button
                                                                                                        loading={this.state.serviceId == item.uId && order.subOrderId == this.state.subOrderId && this.state.loading}
                                                                                                        style={{ background: '#F14A52', color: 'white', borderRadius: '5px', marginTop: '5px', }}
                                                                                                        onClick={() => this.handleUndoItem(s.id, order.subOrderId, item.serviceId, item.status, item.uId)}
                                                                                                    >
                                                                                                        Undo
                                                                                                    </Button>
                                                                                                </div>
                                                                                            }

                                                                                            {item.status == 'COMPLETED' &&
                                                                                                <div style={{ margin: 'auto' ,  marginRight:"21%" }}>
                                                                                                    <p style={{ textAlign: 'center', marginBottom: '7px', marginTop: '7px', color: '#3f51b5', fontWeight: 600 }}>
                                                                                                     COMPLETED</p>
                                                                                                </div>
                                                                                            }

                                                                                            {item.status == 'CANCELLED' &&
                                                                                                <div style={{ margin: 'auto' ,  marginRight:"21%" }}>
                                                                                                    <p style={{ textAlign: 'center', marginBottom: '7px', marginTop: '7px', color: '#3f51b5', fontWeight: 600 }}>
                                                                                                    CANCELLED</p>
                                                                                                </div>
                                                                                            }   
                                                                                             {item.status == 'DISCARDED' &&
                                                                                                <div style={{ margin: 'auto' ,  marginRight:"21%" }}>
                                                                                                    <p style={{ textAlign: 'center', marginBottom: '7px', marginTop: '7px', color: '#3f51b5', fontWeight: 600 }}>
                                                                                                    CANCELLED</p>
                                                                                                </div>
                                                                                            }  

                                                                                            {item.status == 'SHIFTED' &&
                                                                                                <div style={{ margin: 'auto',  marginRight:"21%" }}>
                                                                                                    <p style={{ textAlign: 'center', marginBottom: '7px', marginTop: '7px', color: '#3f51b5', fontWeight: 600 }}>
                                                                                                    SHIFTED</p>
                                                                                                </div>
                                                                                            } 

                                                                                        </List.Item>

                                                                                    </>
                                                                                )}
                                                                            />
                                                                        </div>
                                                                    )
                                                                })
                                                            }

                                                            <Row gutter={10} style={{ marginTop: '5px' }}>
                                                                <Col span={8}>

                                                                    <p style={{ marginBottom: '0px', textAlign: 'justify', marginTop: '0px' }}>
                                                                        <Button style={{ borderRadius: '5px', width: '100%', background: 'none', height: '30px' }}><span style={{ color: 'white' }}>
                                                                            <span className="kitcheNames" style={{ fontSize: '12px', fontWeight: 700 }}>ITEMS:&nbsp; {roundToThree(s.totalCount)}</span>
                                                                        </span>
                                                                        </Button>
                                                                    </p>
                                                                </Col>
                                                            </Row>
                                                        </Card>
                                                    </Col>
                                                }
                                            </>

                                        )

                                    })

                                }
                                </Row> :  <p style={{textAlign:'center',marginTop:'50px'}}><img src='/public/nodata.png' style={{height:'200px'}}/></p>
                        }
                    </>

                }
            </>

        )
    }
}

export default withApollo(serveItems)